/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_UndoInputs */

const en_us2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const pt_br2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

const es_419_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const pt_pt2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular`)
};

const fr_fr2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_de2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig`)
};

const it_it2_exercise_undo = /** @type {(inputs: Exercise_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Exercise_UndoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_undo = /** @type {((inputs?: Exercise_UndoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_UndoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_undo(inputs)
	if (locale === "es-419") return es_419_exercise_undo(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_undo(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_undo(inputs)
	if (locale === "de-DE") return de_de2_exercise_undo(inputs)
	if (locale === "it-IT") return it_it2_exercise_undo(inputs)
	return en_us2_exercise_undo(inputs)
});
export { exercise_undo as "exercise.undo" }